import React from 'react'

export default props => (
  <svg
    {...props}
    fill={props.fill || '#808792'}
    viewBox={props.viewBox || '0 0 12 9'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M11.23 0.935547H0.854996C0.727025 0.935547 0.622559 1.03986 0.622559 1.16783V8.42147C0.622559 8.54944 0.727025 8.6536 0.854996 8.6536H11.2299C11.358 8.6536 11.4622 8.54944 11.4622 8.42147V1.16798C11.4622 1.03986 11.358 0.935547 11.23 0.935547ZM0.887411 1.45527L5.3114 5.08439L0.887411 8.18949V1.45527ZM6.23592 4.97531C6.23531 4.97578 6.23454 4.97593 6.23377 4.97654L6.20904 4.99621L5.89918 5.23679L0.979434 1.20055H11.0973L6.23592 4.97531ZM5.50128 5.24001L5.81637 5.49841C5.83972 5.51792 5.8686 5.5273 5.89718 5.5273C5.92468 5.5273 5.95233 5.51839 5.97537 5.50041L6.32933 5.22557L11.0603 8.38875H1.01492L5.50128 5.24001ZM6.52597 5.07302L11.1973 1.44589V8.19625L6.52597 5.07302Z"
        fill="black"
      />
    </g>
  </svg>
)
